import type { DisplayMode, PopupInstance, DisplayConfig } from '../types';

export class FullscreenDisplayMode implements DisplayMode {
	createContainer(popup: PopupInstance): HTMLElement {
		const { display, feedId } = popup.config;

		const overlay = document.createElement('div');
		overlay.className = `gf-popups-fullscreen ${display.customCssClass}`;
		overlay.dataset.feedId = String(feedId);
		overlay.style.zIndex = String(display.zIndex);
		overlay.style.backgroundColor = display.backdropColor;
		overlay.setAttribute('aria-hidden', 'true');

		if (display.backdropBlur) {
			overlay.style.backdropFilter = 'blur(4px)';
		}

		const inner = document.createElement('div');
		inner.className = 'gf-popups-fullscreen__inner';
		if (display.innerWidth) {
			inner.style.maxWidth = display.innerWidth;
		}

		if (display.showCloseButton) {
			const close = document.createElement('button');
			close.className = 'gf-popups-close';
			close.setAttribute('aria-label', 'Close');
			close.innerHTML = '&times;';
			close.addEventListener('click', () => popup.hide());
			inner.appendChild(close);
		}

		const content = document.createElement('div');
		content.className = 'gf-popups-content';
		inner.appendChild(content);
		overlay.appendChild(inner);

		if (display.closeOnBackdropClick) {
			overlay.addEventListener('click', (e) => {
				if (e.target === overlay) {
					popup.hide();
				}
			});
		}

		return overlay;
	}

	show(container: HTMLElement, config: DisplayConfig): void {
		container.removeAttribute('aria-hidden');
		requestAnimationFrame(() => {
			container.classList.add('gf-popups-fullscreen--visible');
		});
		document.body.style.overflow = 'hidden';
	}

	async hide(container: HTMLElement, config: DisplayConfig): Promise<void> {
		container.classList.remove('gf-popups-fullscreen--visible');
		container.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';
		await new Promise(resolve => setTimeout(resolve, 300));
	}

	destroy(container: HTMLElement): void {
		document.body.style.overflow = '';
		container.remove();
	}
}
